import React from 'react';
import styled from 'styled-components';
import { withRouter } from 'react-router-dom';

import H1 from '../../collections/H1/H1';
import Paragraph from '../../collections/Paragraph/Paragraph';
import Button from '../../collections/LinkButton/LinkButton';

import { media } from '../../utilities/style-utilities';
import { emy, fontUbuntuLight, fontUbuntu } from '../../utilities/utilities';

const InnerWrapper = styled.div`
  flex: 1 1 auto;
  z-index: 1;
`;

const FlexRow = styled.div`
  max-width: 964px;
  width: 100%;
  display: flex;
  justify-content: center;
  z-index: 1;
  margin: 0 auto;
  background-color: ${props => props.backgroundColor ? props.backgroundColor : 'rgb(0, 135, 208)'};
`;

const FlexItem = styled.div`
  flex: 1 1 50%;
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: ${props => props.backgroundColor ? props.backgroundColor : 'rgb(0, 135, 208)'};

  &:nth-child(2) {
    ${ media.desktop`
      display: none;
    `}
  }
`;

const Box = styled.div`
  background: ${props => props.background ? `url(${props.background})` : 'transparent'};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: right;
  padding: 1rem 3rem;
  padding-bottom: 10rem;
  border-top-left-radius: 150% 100%;
  border-top-right-radius: 150% 100%;
  margin-left: 1rem;  
  margin-top: 3rem;
  flex: 1 1 auto;
`;

const Wrapper = styled.div`
  background-color: ${props => props.backgroundColor ? props.backgroundColor : 'transparent'};
  padding: 1rem 2rem;
  padding-bottom: 10rem;
  border-bottom-left-radius: 150% 100%;
  border-bottom-right-radius: 150% 100%;
  margin-right: 1rem;
  margin-bottom: 3rem;
  flex: 1 1 auto;

  ${ media.desktop`
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    border-radius: 0.8rem;
    padding: 2rem 1rem;
    margin: 1rem 1rem;
    box-shadow: 0px 0px 8px 2px rgba(0,0,0,0.25);
  `}

   ${ media.desktop`
    padding: 1rem;
   `}
`;

const LogoWrapper = styled.div`
  display: inline-flex;
  padding: 2rem 0;
  ${ media.desktop`
    display: none;
  `}
`;

const Logo = styled.img`
  max-width: 100%;
  height: auto;
  display: block;
`;

const StyledH1 = styled(H1)`
  text-align: left;
  padding-bottom: 1rem;
  color: ${props => props.titleTextColor ? props.titleTextColor : '#0d1b58'};
  border-bottom: 2px solid ${props => props.dividerColor ? props.dividerColor : '#E6E6E6'};
  
  ${ media.desktop`
    text-align: center;
  `}
  
  ${ media.mobile`
    font-size: 2em;
  `}

`;

const WordGap = styled.span`
  display: inline-flex;
  width: 100%;
  justify-content: center;
  font-size: ${emy(28)};
  font-family: ${props => props.fontFamily ? props.fontFamily : fontUbuntuLight};
  color: ${props => props.textColor ? props.textColor : '#0D1B58'};
`;

const LandingButton = styled(Button)`
  margin: 1rem 0;
  font-weight: 700;
  font-family: ${props => props.fontFamily ? props.fontFamily : fontUbuntu};
  ${ media.mobile`
    font-size: 1em;
  `}
`;

const Landing = (props) => {
  
  return (
    <InnerWrapper>
      <FlexRow backgroundColor={props.landing.backgroundColor}>
        <FlexItem backgroundColor={props.landing.columnLeftBackground}>
          <Wrapper backgroundColor={props.landing.columnLeftInnerBackgroundColor}>

            <LogoWrapper>
              <Logo src={props.landing.logoSrc} alt={props.landing.logoAlt}/>
            </LogoWrapper>
            
            <StyledH1 fontFamily={props.landing.fontFamily} dividerColor={props.landing.titleDividerColor} titleTextColor={props.landing.titleTextColor}>{props.landing.titleText}</StyledH1>
            
            <Paragraph bold fontFamily={props.landing.fontFamily} textColor={props.landing.textColor}>{props.landing.messageText}</Paragraph>
            
            <Paragraph bold fontFamily={props.landing.fontFamily} textColor={props.landing.textColor}>{props.landing.messageSubText}</Paragraph>
            
            <LandingButton to={`${props.url === '/' ? '' : props.url}/card-activation`} 
              fontFamily={props.landing.fontFamily}
              color={props.landing.cardActivationButtonColor} 
              background={props.landing.cardActivationBackgroundColor} 
              border={props.landing.cardActivationButtonBorderColor}>
                {props.landing.cardActivationButtonText}
            </LandingButton>

            <WordGap fontFamily={props.landing.fontFamily} textColor={props.landing.textColor}>or</WordGap>

            <LandingButton to={`${props.url === '/' ? '' : props.url}/pin-retrieval`} 
              fontFamily={props.landing.fontFamily}
              color={props.landing.pinRetrievalButtonColor} 
              background={props.landing.pinRetrievalButtonBackgroundColor} 
              border={props.landing.pinRetrievalButtonBorderColor}>
                {props.landing.pinRetrievalButtonText}
            </LandingButton>

          </Wrapper>
        </FlexItem>

        <FlexItem backgroundColor={props.landing.columnRightBackgroundColor}>
          <Box background={props.landing.columnRightBackground}/>
        </FlexItem>
      </FlexRow>
    </InnerWrapper>  
  )
};

export default withRouter(Landing);


// WEBPACK FOOTER //
// ./src/components/Landing/Landing.js